import React from 'react'
import { Col, List, Row, Space, Typography } from 'antd'

interface ResumeModalContentProps {
  dataSource: { title: string; value: any }[][]
  tableData: any[]
  title?: string
}

export default function ResumeModalContent({
  dataSource,
  tableData = [],
  title,
}: ResumeModalContentProps) {
  return (
    <Row style={{ flexDirection: 'column' }} gutter={[0, 20]}>
      <Row gutter={[48,0]}>
        {dataSource.map((item, index) => (
          <Col span={24 / dataSource.length} key={index}>
            <List
              itemLayout="horizontal"
              style={{ padding: '8px 0' }}
              dataSource={item}
              renderItem={(item, index) => (
                <List.Item>
                  <Space.Compact block style={{ justifyContent: 'space-between' }}>
                    <Typography.Text
                        style={{ fontWeight: 500, color: '#747A83' }}
                      >
                        {item.title}
                      </Typography.Text>
                      <div>{item.value}</div>
                  </Space.Compact>
                </List.Item>
              )}
            />
          </Col>
        ))}
      </Row>
      <Row>
        {' '}
        <Typography.Title style={{ fontSize: '16px' }}>
          {title}
        </Typography.Title>
      </Row>
      <Row
        justify="space-evenly"
        gutter={[48, 0]}
        style={{ marginBottom: '20px' }}
      >
        {tableData.map((item, index) => (
          <Col span={24 / dataSource.length} key={index}>
            { item.length > 0 && <div className="tabUserInfo">
              <List
                itemLayout="horizontal"
                dataSource={item}
                renderItem={(item, index) => (
                  <List.Item>
                    <List.Item.Meta
                      title={
                        <Typography.Text
                          style={{ fontWeight: 500, color: '#747A83' }}
                        >
                          {item.title}
                        </Typography.Text>
                      }
                    />
                    <div>{item.value}</div>
                  </List.Item>
                )}
              />
            </div> }
          </Col>
        ))}
      </Row>
    </Row>
  )
}
